import custom_fetch from "../custom_fetch";
import {BASE_URL} from "./base_url";

const validate_accident_token_b_by_token = (token) => {
    const url = `${BASE_URL}/Accidents/ValidateAccidentTokenBByToken?Token=${encodeURIComponent(token)}`;
    return custom_fetch(url, {
        method: 'POST'
    }).then(data => {
        return JSON.parse(data);
    }).catch(error => {
        throw error;
    })
}

export default validate_accident_token_b_by_token;
